module.exports = __webpack_public_path__ + "img/tienda2.1e5ccdbf.png";